// extracted by mini-css-extract-plugin
export var centerList = "_is-6";
export var centerLoc = "_is-a";
export var centerName = "_is-9";
export var centerOptionBody = "_is-8";
export var centerRow = "_is-7";
export var centerStatus = "_is-b";
export var empty = "_is-5";
export var externalIcon = "_is-c";
export var fieldHeader = "_is-2";
export var fieldHelp = "_is-4";
export var fieldLabel = "_is-3";
export var panel = "_is-0";
export var removeBtn = "_is-d";
export var section = "_is-1";